//
// PC版メニューのドロップダウン＋他全体が暗くなるモーダル風味。
//

// 定数
const listHeight = 27.5; // aのheight (paddingを入れた結果)
const listCategoryHeight = 36; // spanのheight (paddingを入れた結果)
const listWrapperPadding = 16; // ulの上下のpadding
const listWrapperPaddingHeadIsCategory = 4; // ulのstyle-no-top-marginを持っている場合の上のpadding
const paddingBase = 4; // aのpaddingTopとpaddingBottom
const paddingBaseCategoryTop = 16; // spanのpaddingTop
const paddingBaseCategoryBottom = 4; // spanのpaddingBottom
const coefficientPx = 2; // アニメーションでスライドインさせるaの幅
const slideInDeley = 50; // リストの表示を遅らせる時間
const slideOutDeley = 100; // リストの非表示を遅らせる時間
const fadeInSpeed = 10; // msec

export const menuPcDropmodal = {
  addEvent() {
    $("body").on("click", "[data-action='pcModalDropdown']", (e) => {
      this.toggle(e);
    });
    $("body").on("click", ".menu-pc-dropmodal__backdrop", (e) => {
      this.toggle(e);
    });
  },
  getRoot() {
    return $(".menu-pc-dropmodal");
  },
  getList(e, $root) {
    let $list = $root.find("li.menu-pc-dropmodal__list.is-active");
    if (!$list[0]) {
      $list = $(e.target).closest(".menu-pc-dropmodal__list");
    }
    return $list;
  },
  getBackdrop($root) {
    let $backdrop = $root.children(".menu-pc-dropmodal__backdrop");
    if (!$backdrop[0]) {
      $root.append("<div class='menu-pc-dropmodal__backdrop'></div>");
      $backdrop = $root.children(".menu-pc-dropmodal__backdrop");
    }
    return $backdrop;
  },
  getDropdown($list) {
    return $list.find(".menu-pc-dropmodal__dropdown");
  },
  getTrigger($list) {
    return $list.find("[data-action='pcModalDropdown']").first();
  },
  setAriaExpanded($list, expanded) {
    const $trigger = this.getTrigger($list);
    if ($trigger && $trigger.length) {
      $trigger.attr("aria-expanded", expanded ? "true" : "false");
    }
  },
  toggle(e) {
    const $root = this.getRoot(e);
    const $list = this.getList(e, $root);
    if ($root.hasClass("is-active")) {
      this.close($root, $list);
    } else {
      this.open($root, $list, e);
    }
  },

  // 開く
  open($root, $list) {
    $root.addClass("is-active");

    // アクセシビリティ: 展開状態を更新
    this.setAriaExpanded($list, true);

    //
    // arrow (下矢印)
    //
    $list.addClass("is-active");
    setTimeout(() => {
      $list.addClass("is-end");
    }, 10);

    //
    // backdrop (黒背景)
    //
    const $backdrop = this.getBackdrop($root);
    setTimeout(() => {
      $backdrop.addClass("is-active");
    }, 10);

    //
    // list
    //
    const $dropdown = this.getDropdown($list);
    const $ul = $dropdown.children("ul");
    const $lists = $ul.children("li"); // ul要素が複数形でも、すべてのul要素に対してliを取ってくれる。ループを回さなくて良い。
    const listCount = $lists.length;
    const $listsCategories = $dropdown.children("p");
    const listCategoryCount = $listsCategories.length;
    let height = listCount * listHeight + listCategoryCount * listCategoryHeight;

    if ($dropdown.hasClass("style-head-is-category")) {
      height += listWrapperPaddingHeadIsCategory + listWrapperPadding;
    } else {
      height += listWrapperPadding * 2;
    }

    //
    // 事前準備
    //
    // dropdownの高さを10分の1にして、小さい状態から元の状態にして、下へスライドさせている雰囲気を出す。
    $dropdown.css("height", `${height / 10}px`);
    // リストを消す。初期の高さ
    const initialPadding = paddingBase - coefficientPx;
    const initialPaddingCategoryTop = paddingBaseCategoryTop - coefficientPx;
    const initialPaddingCategoryBottom = paddingBaseCategoryBottom - coefficientPx;

    $lists.each((index, list) => {
      $(list).children("a").css("padding-top", `${initialPadding}px`);
      $(list).children("a").css("padding-bottom", `${initialPadding}px`);
      $(list).children("a").css("opacity", "0");
    });

    $listsCategories.each((index, list) => {
      $(list).css("padding-top", `${initialPaddingCategoryTop}px`);
      $(list).css("padding-bottom", `${initialPaddingCategoryBottom}px`);
      $(list).css("opacity", "0");
    });

    //
    // dropdown (白背景)
    //
    // アニメーションを付与する
    setTimeout(() => {
      $dropdown.addClass("is-transition");
    }, 10);
    // 高さを元に戻す。アニメーション時間はCSSでコントロール。100msecを指定している。
    setTimeout(() => {
      $dropdown.css("height", `${height}px`);
    }, 20);

    //
    // リストのスライドイン
    //

    // ulを表示に切り替える
    setTimeout(() => {
      $ul.css("opacity", "1");
    }, slideInDeley);

    const combinedItems = [];
    $lists.each((_, list) => {
      combinedItems.push({ el: list, top: $(list).offset().top, type: "list" });
    });
    $listsCategories.each((_, list) => {
      combinedItems.push({ el: list, top: $(list).offset().top, type: "category" });
    });

    combinedItems.sort((a, b) => a.top - b.top);

    combinedItems.forEach((item, index) => {
      setTimeout(
        () => {
          if (item.type === "list") {
            $(item.el).children("a").css("padding-top", `${paddingBase}px`);
            $(item.el).children("a").css("padding-bottom", `${paddingBase}px`);
            $(item.el).children("a").css("opacity", "1");
          } else {
            $(item.el).css("padding-top", `${paddingBaseCategoryTop}px`);
            $(item.el).css("padding-bottom", `${paddingBaseCategoryBottom}px`);
            $(item.el).css("opacity", "1");
          }
        },
        slideInDeley + index * fadeInSpeed,
      );
    });
  },

  // 閉じる
  close($root, $list) {
    // アクセシビリティ: 展開状態を更新
    this.setAriaExpanded($list, false);

    $list.removeClass("is-end");

    const $dropdown = this.getDropdown($list);
    const $backdrop = this.getBackdrop($root);

    const $ul = $dropdown.children("ul");
    const $lists = $ul.children("li");
    const listCount = $lists.length;

    const $listsCategories = $dropdown.children("p");
    const listCategoryCount = $listsCategories.length;

    let height = listCount * listHeight + listCategoryCount * listCategoryHeight;
    if ($dropdown.hasClass("style-head-is-category")) {
      height += listWrapperPaddingHeadIsCategory + listWrapperPadding;
    } else {
      height += listWrapperPadding * 2;
    }

    setTimeout(() => {
      $backdrop.removeClass("is-active");
    }, 10);

    // 消すときは一斉に。
    const initialPadding = paddingBase - coefficientPx;
    const initialPaddingCategoryTop = paddingBaseCategoryTop - coefficientPx;
    const initialPaddingCategoryBottom = paddingBaseCategoryBottom - coefficientPx;
    $lists.each((index, list) => {
      setTimeout(() => {
        $(list).children("a").css("padding-top", `${initialPadding}px`);
        $(list).children("a").css("padding-bottom", `${initialPadding}px`);
        $(list).children("a").css("opacity", "0");
      }, 10);
    });

    $listsCategories.each((index, list) => {
      setTimeout(() => {
        $(list).css("padding-top", `${initialPaddingCategoryTop}px`);
        $(list).css("padding-bottom", `${initialPaddingCategoryBottom}px`);
        $(list).css("opacity", "0");
      }, 10);
    });

    // 全部が終わったら高さを消す
    setTimeout(() => {
      $dropdown.css("height", `${height / 10}px`);
    }, slideOutDeley);

    // 全ての状態の削除
    setTimeout(() => {
      $dropdown.removeClass("is-active");
      $root.removeClass("is-active");
      $list.removeClass("is-active");
    }, slideOutDeley + 150); // heightのtransitionを0.2秒にしているので。
  },
};
